/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class Countdown {
  constructor(target_id, start_time) {
    if (target_id == null) { target_id = "span#countdown"; }
    this.target_id = target_id;
    if (start_time == null) { start_time = "125"; }
    this.start_time = start_time;
  }

  init() {
    this.reset();
    window.tick = () => {
      return this.tick();
    };
    return setInterval(window.tick, 1000);
  }

  reset() {
    const time = this.start_time;
    this.minutes = Math.floor(this.start_time / 60);
    if (this.minutes < 10) { this.minutes = '0' + this.minutes; }
    this.seconds = this.start_time % 60;
    return this.updateTarget();
  }

  tick() {
    const [seconds, minutes] = Array.from([this.seconds, this.minutes]);
    if ((seconds > 0) || (minutes > 0)) {
      if (seconds === 0) {
        this.minutes = minutes - 1;
        if (this.minutes < 10) { this.minutes = '0' + this.minutes; }
        this.seconds = 59;
      } else {
        this.seconds = seconds - 1;
      }
    }

    if ((seconds <= 0) && (minutes <= 0)) {
      window.location.reload();
    }

    return this.updateTarget();
  }

  updateTarget() {
    let {
      seconds
    } = this;
    if (seconds < 10) { seconds = '0' + seconds; }
    return $(this.target_id).html(this.minutes + ":" + seconds);
  }
}

window.Countdown = Countdown;